<template>
  <div>
    <hr color="B3C3EC">
    <div class="content">
    我们为每一位来到幻之大地的朋友提供40点的初始属性点，您可以平均分配到8种基本属性上，也可打造属于您自己独特的属性分配。
    所有的选择都在您手中，我的朋友。。。<br/>
    可分配属性点：{{total}}
     <el-button type="primary" plain size="mini" @click="average();">平均分配</el-button>
     <el-button type="primary" plain size="mini" @click="resetProp();">重置</el-button>
     
     <el-button type="primary" plain size="mini" @click="initProperties();">确定初始化</el-button>
    <div class="block">
      <span class="demonstration">容貌</span>
      <el-slider v-model="rongmao" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">毅力</span>
      <el-slider v-model="yili" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">臂力</span>
      <el-slider v-model="bili" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">悟性</span>
      <el-slider v-model="wuxing" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">热情</span>
      <el-slider v-model="reqing" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">嗓音</span>
      <el-slider v-model="sangyin" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">魄力</span>
      <el-slider v-model="poli" :max="maxValue" @change="change"></el-slider>
    </div>
    <div class="block">
      <span class="demonstration">反应</span>
      <el-slider v-model="fanying" :max="maxValue" @change="change"></el-slider>
    </div>
    <hr color="B3C3EC">
    </div>
  </div>
</template>
<script>
  import {postRequest} from '../../utils/api'
  import Message from 'element-ui/lib/message'
  export default{
    data(){
      return {
        maxValue: 40,
        total: 40,
        rongmao: 0,
        yili: 0,
        bili: 0,
        wuxing: 0,
        reqing: 0,
        sangyin: 0,
        poli: 0,
        fanying: 0,
      }
    },
    mounted: function () {
      //this.verifyUserEmail();
    },
    methods: {
      change(value) {
        let sum = this.calc();
        if (this.maxValue - sum < 0) {
          Message.error("您没有足够的属性点，请重新规划。");
        }
      },
      calc() {
        let sum = this.rongmao + this.yili + this.bili + this.wuxing + this.reqing 
        + this.sangyin + this.poli + this.fanying;
        this.total = this.maxValue - sum;
        return sum;

      },
      average: function() {
        this.rongmao = 5;
        this.yili = 5;
        this.bili = 5;
        this.wuxing = 5;
        this.reqing = 5;
        this.sangyin = 5;
        this.poli = 5;
        this.fanying = 5;
        this.total = 0;
      },
      resetProp: function() {
        this.rongmao = 0;
        this.yili = 0;
        this.bili = 0;
        this.wuxing = 0;
        this.reqing = 0;
        this.sangyin = 0;
        this.poli = 0;
        this.fanying = 0;
        this.total = 40;
      },
      initProperties: function() {
        let sum = this.calc();
        if (this.maxValue - sum < 0) {
          Message.error("您没有足够的属性点，请重新规划。");
          return false;
        }
        if (sum < this.maxValue) {
          Message.error("您还有 " + (this.maxValue - sum) + " 点属性点未分配，请分配完40点后再进行初始化。");
          return false;
        }
        let _this = this;
        this.$confirm('您使用了<span style="color:red">' + sum + '</span>点属性点，确定要初始化属性吗?属性点在幻之大地可是很重要的元素啊，确认后将无法更改，请慎重决定。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString:true,
            type: 'warning',
            appendToBody: true,
            zIndex: 3000
        }).then(function () {
          postRequest('/user/user/initProperties', {
            rongmao: _this.rongmao,
            yili: _this.yili,
            bili: _this.bili,
            wuxing: _this.wuxing,
            reqing: _this.reqing,
            sangyin: _this.sangyin,
            poli: _this.poli,
            fanying: _this.fanying
          }).then(resp=> {
            if (resp.status == 200) {
              //成功
              var respData = resp.data;
              if (200 == respData.status) {
                Message.success("您已成功规划属性点。");
                _this.$router.replace({path: '/initUserHeader.html'});
              } else {
                Message.error(respData.message);
                _this.$router.replace({path: '/'});
              }
            } else {
              //失败
              Message.error('用户非法⊙﹏⊙∥!');
              _this.$router.replace({path: '/'});
            }
          }, resp=> {
            Message.error('用户非法⊙﹏⊙∥!');
            _this.$router.replace({path: '/'});
          });
        }, function () {
            //取消
        })
      }
    }
  }
  
</script>
<style scoped>
  .content a {
    cursor: pointer;
    color: blue;
    text-decoration:none;
  }
  .content a:hover {text-decoration:underline;color:#FF0000}
  .content {
    line-height: 2em;
  }
  .block {
    padding: 0px 24px;
    overflow: hidden;
    border-bottom: 1px solid #eff2f6;
  }
  .block .demonstration {
    font-size: 14px;
    color: #8492a6;
    line-height: 38px;
  }
  .block .el-slider {
    float: right;
    width: 70%;
    margin-right: 20px;
  }
  .block .el-slider /deep/ .el-slider__button-wrapper {
    z-index: 0 !important;
  }
</style>
